// Page-level content for the landing home. Section components are layout-only.
// ─── Featured property ──────────────────────────────────────────────────────
// Narrative copy for the Featured Property spotlight. The property itself is
// admin-curated, so the body is a template: `title` is the property, `community`
// the district it sits in. `community` falls back when a property has no district.
export const FEATURED_PROPERTY_HEADING = 'Featured Property';
export const FEATURED_PROPERTY_COMMUNITY_FALLBACK = 'local';
export const featuredPropertyBody = (title, community) => `Discover the story behind ${title} and how this property shaped the ${community} community.`;
// ─── Explore by role ────────────────────────────────────────────────────────
// Copy for the "Explore by Role" tabbed section. One entry per role in
// `role.ts`; the tab framework reads whichever entry is active, so filling in a
// role is an edit here and nothing else.
export const ROLE_SECTION_HEADING = 'See How 76UNBOXED Fits Your Needs';
export const roleCtaLabel = (role) => `Learn more about ${role}`;
export const ROLE_PANELS = {
    'explore-local-government': {
        headline: 'Manage preservation with confidence.',
        body: '76UNBOXED provides the tools for municipalities to efficiently manage their properties and keep the public informed.',
        bullets: [
            'Custom maps',
            'Public engagement & transparency',
            'Public & private discussion groups',
        ],
        media: {
            src: '/images/landing/explore-by-role/local-gov.jpeg',
            alt: 'Illustration of a columned civic building with a domed roof, red doors, and a flag flying above it.',
        },
    },
    'explore-historic-association': {
        headline: 'Preservation is stronger together.',
        body: "76UNBOXED gives your association the tools to organize knowledge, mobilize members, and tell your community's story.",
        bullets: [
            'Discussion groups & member contributions',
            'Organized photo & document uploads',
            'Visibility that builds trust and membership',
            'Facilitate collaboration between members',
            'Share announcements and upcoming events',
        ],
        media: {
            src: '/images/landing/explore-by-role/historic-association.jpeg',
            alt: 'Illustration of a historic house and steepled tower with a row of five people standing together in front of them.',
        },
    },
    'explore-homeowner': {
        headline: 'Your home is part of the story.',
        body: '76UNBOXED helps homeowners and community members contribute to their local history and explore the places around them.',
        bullets: [
            'Add your own photos & memories',
            'Connect with neighbors about community history',
            "Manage your property's repairs, renovations, and records",
            'Access resources from your historic district board',
        ],
        media: {
            src: '/images/landing/explore-by-role/homeowner.jpeg',
            alt: 'Illustration of a two-story house with a red front door, dormer window, and landscaped garden.',
        },
    },
};
// ─── Partnerships ───────────────────────────────────────────────────────────
// Copy for the partner seals shown on the home page. Which communities appear is
// managed under System → Partners, and each seal's title, logo, and link are read
// from that community's own record — all three are admin-editable, so holding
// them here would drift the moment a community renames or rebrands.
export const PARTNERSHIPS_HEADING = 'Partnerships';
export const PARTNERSHIPS_BODY = 'We build alongside the districts we serve. These communities are shaping the platform from the ground up.';
